module.exports = __webpack_public_path__ + "static/media/ResponPic6.b68f76d2.jpg";